/// <reference types="./uuid.d.mts" />
import * as $crypto from "../../gleam_crypto/gleam/crypto.mjs";
import * as $bit_array from "../../gleam_stdlib/gleam/bit_array.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import {
  Ok,
  Error,
  toList,
  CustomType as $CustomType,
  makeError,
  remainderInt,
  divideInt,
  toBitArray,
  bitArraySlice,
  bitArraySliceToInt,
  sizedInt,
} from "../gleam.mjs";

const FILEPATH = "src/youid/uuid.gleam";

class Uuid extends $CustomType {
  constructor(value) {
    super();
    this.value = value;
  }
}

export class V1 extends $CustomType {}

export class V2 extends $CustomType {}

export class V3 extends $CustomType {}

export class V4 extends $CustomType {}

export class V5 extends $CustomType {}

export class V7 extends $CustomType {}

export class VUnknown extends $CustomType {}

export class ReservedFuture extends $CustomType {}

export class ReservedMicrosoft extends $CustomType {}

export class ReservedNcs extends $CustomType {}

export class Rfc4122 extends $CustomType {}

export class String extends $CustomType {}

export class Hex extends $CustomType {}

export class Urn extends $CustomType {}

export class DefaultNode extends $CustomType {}

export class RandomNode extends $CustomType {}

export class CustomNode extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class RandomClockSeq extends $CustomType {}

export class CustomClockSeq extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

function random_uuid1_clockseq() {
  let $ = $crypto.strong_random_bytes(2);
  if ($.bitSize !== 16) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      180,
      "random_uuid1_clockseq",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 4521,
        end: 4597,
        pattern_start: 4532,
        pattern_end: 4565
      }
    )
  }
  let clock_seq = bitArraySliceToInt($, 0, 14, true, false);
  return toBitArray([sizedInt(clock_seq, 14, true)]);
}

function validate_clock_seq(clock_seq) {
  if (clock_seq instanceof RandomClockSeq) {
    return new Ok(random_uuid1_clockseq());
  } else {
    let bs = clock_seq[0];
    let $ = $bit_array.bit_size(bs) === 14;
    if ($) {
      return new Ok(bs);
    } else {
      return new Error(undefined);
    }
  }
}

function random_uuid1_node() {
  let $ = $crypto.strong_random_bytes(6);
  if ($.bitSize !== 48) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      196,
      "random_uuid1_node",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 5012,
        end: 5106,
        pattern_start: 5023,
        pattern_end: 5070
      }
    )
  }
  let rnd_hi = bitArraySliceToInt($, 0, 7, true, false);
  let rnd_low = bitArraySliceToInt($, 8, 48, true, false);
  return toBitArray([
    sizedInt(rnd_hi, 7, true),
    sizedInt(1, 1, true),
    sizedInt(rnd_low, 40, true),
  ]);
}

function md5(data) {
  return $crypto.hash(new $crypto.Md5(), data);
}

function sha1(data) {
  let $ = $crypto.hash(new $crypto.Sha1(), data);
  if ($.bitSize !== 160) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      279,
      "sha1",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 6818,
        end: 6891,
        pattern_start: 6829,
        pattern_end: 6858
      }
    )
  }
  let data$1 = bitArraySlice($, 0, 128);
  return data$1;
}

export function time(uuid) {
  let $ = uuid.value;
  if ($.bitSize !== 128) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      355,
      "time",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 8994,
        end: 9060,
        pattern_start: 9005,
        pattern_end: 9047
      }
    )
  }
  let t_low = bitArraySliceToInt($, 0, 32, true, false);
  let t_mid = bitArraySliceToInt($, 32, 48, true, false);
  let t_hi = bitArraySliceToInt($, 52, 64, true, false);
  let $1 = toBitArray([
    sizedInt(t_hi, 12, true),
    sizedInt(t_mid, 16, true),
    sizedInt(t_low, 32, true),
  ]);
  if ($1.bitSize !== 60) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      356,
      "time",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $1,
        start: 9063,
        end: 9116,
        pattern_start: 9074,
        pattern_end: 9082
      }
    )
  }
  let t = bitArraySliceToInt($1, 0, 60, true, false);
  return t;
}

export function clock_sequence(uuid) {
  let $ = uuid.value;
  if ($.bitSize !== 128) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      378,
      "clock_sequence",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 9648,
        end: 9700,
        pattern_start: 9659,
        pattern_end: 9687
      }
    )
  }
  let clock_seq = bitArraySliceToInt($, 66, 80, true, false);
  return clock_seq;
}

export function node(uuid) {
  let $ = uuid.value;
  if ($.bitSize !== 128) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      385,
      "node",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 9826,
        end: 9975,
        pattern_start: 9837,
        pattern_end: 9962
      }
    )
  }
  let a = bitArraySliceToInt($, 80, 84, true, false);
  let b = bitArraySliceToInt($, 84, 88, true, false);
  let c = bitArraySliceToInt($, 88, 92, true, false);
  let d = bitArraySliceToInt($, 92, 96, true, false);
  let e = bitArraySliceToInt($, 96, 100, true, false);
  let f = bitArraySliceToInt($, 100, 104, true, false);
  let g = bitArraySliceToInt($, 104, 108, true, false);
  let h = bitArraySliceToInt($, 108, 112, true, false);
  let i = bitArraySliceToInt($, 112, 116, true, false);
  let j = bitArraySliceToInt($, 116, 120, true, false);
  let k = bitArraySliceToInt($, 120, 124, true, false);
  let l = bitArraySliceToInt($, 124, 128, true, false);
  let _pipe = toList([a, b, c, d, e, f, g, h, i, j, k, l]);
  let _pipe$1 = $list.map(_pipe, $int.to_base16);
  return $string.concat(_pipe$1);
}

function to_string_help(loop$ints, loop$position, loop$acc, loop$separator) {
  while (true) {
    let ints = loop$ints;
    let position = loop$position;
    let acc = loop$acc;
    let separator = loop$separator;
    if (position === 8) {
      loop$ints = ints;
      loop$position = position + 1;
      loop$acc = acc + separator;
      loop$separator = separator;
    } else if (position === 13) {
      loop$ints = ints;
      loop$position = position + 1;
      loop$acc = acc + separator;
      loop$separator = separator;
    } else if (position === 18) {
      loop$ints = ints;
      loop$position = position + 1;
      loop$acc = acc + separator;
      loop$separator = separator;
    } else if (position === 23) {
      loop$ints = ints;
      loop$position = position + 1;
      loop$acc = acc + separator;
      loop$separator = separator;
    } else {
      if (ints.bitSize >= 4) {
        let i = bitArraySliceToInt(ints, 0, 4, true, false);
        let rest = bitArraySlice(ints, 4);
        let _block;
        let _pipe = $int.to_base16(i);
        _block = $string.lowercase(_pipe);
        let string = _block;
        loop$ints = rest;
        loop$position = position + 1;
        loop$acc = acc + string;
        loop$separator = separator;
      } else {
        return acc;
      }
    }
  }
}

export function dns_uuid() {
  return new Uuid(
    toBitArray([
      107,
      167,
      184,
      16,
      157,
      173,
      17,
      209,
      128,
      180,
      0,
      192,
      79,
      212,
      48,
      200,
    ]),
  );
}

export function url_uuid() {
  return new Uuid(
    toBitArray([
      107,
      167,
      184,
      17,
      157,
      173,
      17,
      209,
      128,
      180,
      0,
      192,
      79,
      212,
      48,
      200,
    ]),
  );
}

export function oid_uuid() {
  return new Uuid(
    toBitArray([
      107,
      167,
      184,
      18,
      157,
      173,
      17,
      209,
      128,
      180,
      0,
      192,
      79,
      212,
      48,
      200,
    ]),
  );
}

export function x500_uuid() {
  return new Uuid(
    toBitArray([
      107,
      167,
      184,
      19,
      157,
      173,
      17,
      209,
      128,
      180,
      0,
      192,
      79,
      212,
      48,
      200,
    ]),
  );
}

export function to_bit_array(uuid) {
  return uuid.value;
}

function decode_version(int) {
  if (int === 1) {
    return new V1();
  } else if (int === 2) {
    return new V2();
  } else if (int === 3) {
    return new V3();
  } else if (int === 4) {
    return new V4();
  } else if (int === 5) {
    return new V5();
  } else if (int === 7) {
    return new V7();
  } else {
    return new VUnknown();
  }
}

export function version(uuid) {
  let $ = uuid.value;
  if ($.bitSize !== 128) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      337,
      "version",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 8390,
        end: 8435,
        pattern_start: 8401,
        pattern_end: 8422
      }
    )
  }
  let ver = bitArraySliceToInt($, 48, 52, true, false);
  return decode_version(ver);
}

export function from_bit_array(bit_array) {
  let uuid = new Uuid(bit_array);
  let $ = $bit_array.byte_size(bit_array);
  if ($ === 16) {
    let $1 = version(uuid);
    if ($1 instanceof VUnknown) {
      return new Error(undefined);
    } else {
      return new Ok(uuid);
    }
  } else {
    return new Error(undefined);
  }
}

function decode_variant(variant_bits) {
  if (variant_bits.bitSize >= 1) {
    if (bitArraySliceToInt(variant_bits, 0, 1, true, false) === 1) {
      if (variant_bits.bitSize >= 2) {
        if (bitArraySliceToInt(variant_bits, 1, 2, true, false) === 1) {
          if (variant_bits.bitSize === 3) {
            if (bitArraySliceToInt(variant_bits, 2, 3, true, false) === 1) {
              return new ReservedFuture();
            } else if (bitArraySliceToInt(variant_bits, 2, 3, true, false) === 0) {
              return new ReservedMicrosoft();
            } else if (bitArraySliceToInt(variant_bits, 1, 2, true, false) === 0) {
              return new Rfc4122();
            } else if (bitArraySliceToInt(variant_bits, 0, 1, true, false) === 0) {
              return new ReservedNcs();
            } else {
              return new ReservedNcs();
            }
          } else {
            return new ReservedNcs();
          }
        } else if (bitArraySliceToInt(variant_bits, 1, 2, true, false) === 0) {
          if (variant_bits.bitSize === 3) {
            return new Rfc4122();
          } else {
            return new ReservedNcs();
          }
        } else if (bitArraySliceToInt(variant_bits, 0, 1, true, false) === 0) {
          if (variant_bits.bitSize === 3) {
            return new ReservedNcs();
          } else {
            return new ReservedNcs();
          }
        } else {
          return new ReservedNcs();
        }
      } else {
        return new ReservedNcs();
      }
    } else if (bitArraySliceToInt(variant_bits, 0, 1, true, false) === 0) {
      if (variant_bits.bitSize >= 2) {
        if (variant_bits.bitSize === 3) {
          return new ReservedNcs();
        } else {
          return new ReservedNcs();
        }
      } else {
        return new ReservedNcs();
      }
    } else {
      return new ReservedNcs();
    }
  } else {
    return new ReservedNcs();
  }
}

export function variant(uuid) {
  let $ = uuid.value;
  if ($.bitSize !== 128) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      343,
      "variant",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 8539,
        end: 8584,
        pattern_start: 8550,
        pattern_end: 8571
      }
    )
  }
  let var$ = bitArraySliceToInt($, 64, 67, true, false);
  return decode_variant(toBitArray([sizedInt(var$, 3, true)]));
}

function hex_to_int(c) {
  let _block;
  if (c === "0") {
    _block = 0;
  } else if (c === "1") {
    _block = 1;
  } else if (c === "2") {
    _block = 2;
  } else if (c === "3") {
    _block = 3;
  } else if (c === "4") {
    _block = 4;
  } else if (c === "5") {
    _block = 5;
  } else if (c === "6") {
    _block = 6;
  } else if (c === "7") {
    _block = 7;
  } else if (c === "8") {
    _block = 8;
  } else if (c === "9") {
    _block = 9;
  } else if (c === "a") {
    _block = 10;
  } else if (c === "A") {
    _block = 10;
  } else if (c === "b") {
    _block = 11;
  } else if (c === "B") {
    _block = 11;
  } else if (c === "c") {
    _block = 12;
  } else if (c === "C") {
    _block = 12;
  } else if (c === "d") {
    _block = 13;
  } else if (c === "D") {
    _block = 13;
  } else if (c === "e") {
    _block = 14;
  } else if (c === "E") {
    _block = 14;
  } else if (c === "f") {
    _block = 15;
  } else if (c === "F") {
    _block = 15;
  } else {
    _block = 16;
  }
  let i = _block;
  if (i === 16) {
    return new Error(undefined);
  } else {
    let x = i;
    return new Ok(x);
  }
}

function validate_custom_node(loop$str, loop$index, loop$acc) {
  while (true) {
    let str = loop$str;
    let index = loop$index;
    let acc = loop$acc;
    let $ = $string.pop_grapheme(str);
    if ($ instanceof Ok) {
      let $1 = $[0][0];
      if ($1 === ":") {
        let rest = $[0][1];
        loop$str = rest;
        loop$index = index;
        loop$acc = acc;
      } else {
        let c = $1;
        let rest = $[0][1];
        let $2 = hex_to_int(c);
        if ($2 instanceof Ok) {
          if (index < 12) {
            let i = $2[0];
            loop$str = rest;
            loop$index = index + 1;
            loop$acc = toBitArray([acc, sizedInt(i, 4, true)]);
          } else {
            return new Error(undefined);
          }
        } else {
          return new Error(undefined);
        }
      }
    } else if (index === 12) {
      return new Ok(acc);
    } else {
      return new Error(undefined);
    }
  }
}

function to_bitstring_help(loop$str, loop$index, loop$acc) {
  while (true) {
    let str = loop$str;
    let index = loop$index;
    let acc = loop$acc;
    let $ = $string.pop_grapheme(str);
    if ($ instanceof Ok) {
      let $1 = $[0][0];
      if ($1 === "-") {
        if (index < 32) {
          let rest = $[0][1];
          loop$str = rest;
          loop$index = index;
          loop$acc = acc;
        } else {
          if (index < 32) {
            let c = $1;
            let rest = $[0][1];
            let $2 = hex_to_int(c);
            if ($2 instanceof Ok) {
              let i = $2[0];
              loop$str = rest;
              loop$index = index + 1;
              loop$acc = toBitArray([acc, sizedInt(i, 4, true)]);
            } else {
              return new Error(undefined);
            }
          } else {
            return new Error(undefined);
          }
        }
      } else if (index < 32) {
        let c = $1;
        let rest = $[0][1];
        let $2 = hex_to_int(c);
        if ($2 instanceof Ok) {
          let i = $2[0];
          loop$str = rest;
          loop$index = index + 1;
          loop$acc = toBitArray([acc, sizedInt(i, 4, true)]);
        } else {
          return new Error(undefined);
        }
      } else {
        return new Error(undefined);
      }
    } else if (index === 32) {
      return new Ok(acc);
    } else {
      return new Error(undefined);
    }
  }
}

function to_bit_array_helper(str) {
  return to_bitstring_help(str, 0, toBitArray([]));
}

export function from_string(in$) {
  let _block;
  if (in$.startsWith("urn:uuid:")) {
    let in$1 = in$.slice(9);
    _block = in$1;
  } else {
    _block = in$;
  }
  let hex = _block;
  let $ = to_bit_array_helper(hex);
  if ($ instanceof Ok) {
    let bits = $[0];
    return new Ok(new Uuid(bits));
  } else {
    return new Error(undefined);
  }
}

function mac_address() {
  return new Error(undefined);
}

function default_uuid1_node() {
  let $ = mac_address();
  if ($ instanceof Ok) {
    let node$1 = $[0];
    return node$1;
  } else {
    return random_uuid1_node();
  }
}

function validate_node(node) {
  if (node instanceof DefaultNode) {
    return new Ok(default_uuid1_node());
  } else if (node instanceof RandomNode) {
    return new Ok(random_uuid1_node());
  } else {
    let str = node[0];
    return validate_custom_node(str, 0, toBitArray([]));
  }
}

const ms_intervals_offset = 122_192_928_000_000;

function uuid1_time() {
  let _block;
  let _pipe = $timestamp.system_time();
  _block = $timestamp.to_unix_seconds_and_nanoseconds(_pipe);
  let $ = _block;
  let sec = $[0];
  let ns = $[1];
  let time$1 = (sec * 10_000_000 + (divideInt(ns, 100))) + ms_intervals_offset * 1000;
  return toBitArray([sizedInt(time$1, 60, true)]);
}

const nanosec_intervals_factor = 10;

export function time_posix_microsec(uuid) {
  let $ = version(uuid);
  if ($ instanceof V7) {
    let $1 = uuid.value;
    if ($1.bitSize !== 128) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "youid/uuid",
        368,
        "time_posix_microsec",
        "Pattern match failed, no pattern matched the value.",
        {
          value: $1,
          start: 9374,
          end: 9412,
          pattern_start: 9385,
          pattern_end: 9399
        }
      )
    }
    let t = bitArraySliceToInt($1, 0, 48, true, false);
    return t * 1000;
  } else {
    return divideInt(
      (time(uuid) - ms_intervals_offset * 1000),
      nanosec_intervals_factor
    );
  }
}

export function time_posix_millisec(uuid) {
  let $ = version(uuid);
  if ($ instanceof V1) {
    return divideInt(
      (divideInt(
        (time(uuid) - ms_intervals_offset * 1000),
        nanosec_intervals_factor
      )),
      1000
    );
  } else {
    let $1 = uuid.value;
    if ($1.bitSize !== 128) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "youid/uuid",
        414,
        "time_posix_millisec",
        "Pattern match failed, no pattern matched the value.",
        {
          value: $1,
          start: 10421,
          end: 10459,
          pattern_start: 10432,
          pattern_end: 10446
        }
      )
    }
    let t = bitArraySliceToInt($1, 0, 48, true, false);
    return t;
  }
}

const rfc_variant = 2;

function hash_to_uuid_value(hash, ver) {
  if (hash.bitSize !== 128) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      223,
      "hash_to_uuid_value",
      "Pattern match failed, no pattern matched the value.",
      {
        value: hash,
        start: 5683,
        end: 5830,
        pattern_start: 5694,
        pattern_end: 5823
      }
    )
  }
  let time_low = bitArraySliceToInt(hash, 0, 32, true, false);
  let time_mid = bitArraySliceToInt(hash, 32, 48, true, false);
  let time_hi = bitArraySliceToInt(hash, 52, 64, true, false);
  let clock_seq_hi = bitArraySliceToInt(hash, 66, 72, true, false);
  let clock_seq_low = hash.byteAt(9);
  let node$1 = bitArraySliceToInt(hash, 80, 128, true, false);
  return toBitArray([
    sizedInt(time_low, 32, true),
    sizedInt(time_mid, 16, true),
    sizedInt(ver, 4, true),
    sizedInt(time_hi, 12, true),
    sizedInt(rfc_variant, 2, true),
    sizedInt(clock_seq_hi, 6, true),
    clock_seq_low,
    sizedInt(node$1, 48, true),
  ]);
}

const urn_id = "urn:uuid:";

export function format(uuid, format) {
  let _block;
  if (format instanceof String) {
    _block = "-";
  } else {
    _block = "";
  }
  let separator = _block;
  let _block$1;
  if (format instanceof Urn) {
    _block$1 = urn_id;
  } else {
    _block$1 = "";
  }
  let start = _block$1;
  return to_string_help(uuid.value, 0, start, separator);
}

export function to_string(uuid) {
  return format(uuid, new String());
}

const v1_version = 1;

function do_v1(node, clock_seq) {
  if (node.bitSize !== 48) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      118,
      "do_v1",
      "Pattern match failed, no pattern matched the value.",
      {
        value: node,
        start: 2882,
        end: 2911,
        pattern_start: 2893,
        pattern_end: 2904
      }
    )
  }
  let node$1 = bitArraySliceToInt(node, 0, 48, true, false);
  let $ = uuid1_time();
  if ($.bitSize !== 60) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      119,
      "do_v1",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 2914,
        end: 2980,
        pattern_start: 2925,
        pattern_end: 2965
      }
    )
  }
  let time_hi = bitArraySliceToInt($, 0, 12, true, false);
  let time_mid = bitArraySliceToInt($, 12, 28, true, false);
  let time_low = bitArraySliceToInt($, 28, 60, true, false);
  if (clock_seq.bitSize !== 14) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      120,
      "do_v1",
      "Pattern match failed, no pattern matched the value.",
      {
        value: clock_seq,
        start: 2983,
        end: 3022,
        pattern_start: 2994,
        pattern_end: 3010
      }
    )
  }
  let clock_seq$1 = bitArraySliceToInt(clock_seq, 0, 14, true, false);
  let value = toBitArray([
    sizedInt(time_low, 32, true),
    sizedInt(time_mid, 16, true),
    sizedInt(v1_version, 4, true),
    sizedInt(time_hi, 12, true),
    sizedInt(rfc_variant, 2, true),
    sizedInt(clock_seq$1, 14, true),
    sizedInt(node$1, 48, true),
  ]);
  return new Uuid(value);
}

export function v1() {
  return do_v1(default_uuid1_node(), random_uuid1_clockseq());
}

export function v1_string() {
  let _pipe = v1();
  return to_string(_pipe);
}

export function v1_custom(node, clock_seq) {
  let $ = validate_node(node);
  let $1 = validate_clock_seq(clock_seq);
  if ($1 instanceof Ok) {
    if ($ instanceof Ok) {
      let cs = $1[0];
      let n = $[0];
      return new Ok(do_v1(n, cs));
    } else {
      return new Error(undefined);
    }
  } else {
    return new Error(undefined);
  }
}

const v3_version = 3;

export function v3(namespace, name) {
  let $ = (remainderInt($bit_array.bit_size(name), 8)) === 0;
  if ($) {
    let _pipe = toBitArray([namespace.value, name]);
    let _pipe$1 = md5(_pipe);
    let _pipe$2 = hash_to_uuid_value(_pipe$1, v3_version);
    let _pipe$3 = new Uuid(_pipe$2);
    return new Ok(_pipe$3);
  } else {
    return new Error(undefined);
  }
}

const v4_version = 4;

export function v4() {
  let $ = $crypto.strong_random_bytes(16);
  if ($.bitSize !== 128) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      245,
      "v4",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 6032,
        end: 6140,
        pattern_start: 6043,
        pattern_end: 6103
      }
    )
  }
  let a = bitArraySliceToInt($, 0, 48, true, false);
  let b = bitArraySliceToInt($, 52, 64, true, false);
  let c = bitArraySliceToInt($, 66, 128, true, false);
  let value = toBitArray([
    sizedInt(a, 48, true),
    sizedInt(v4_version, 4, true),
    sizedInt(b, 12, true),
    sizedInt(rfc_variant, 2, true),
    sizedInt(c, 62, true),
  ]);
  return new Uuid(value);
}

export function v4_string() {
  let _pipe = v4();
  return format(_pipe, new String());
}

const v5_version = 5;

export function v5(namespace, name) {
  let $ = (remainderInt($bit_array.bit_size(name), 8)) === 0;
  if ($) {
    let _pipe = toBitArray([namespace.value, name]);
    let _pipe$1 = sha1(_pipe);
    let _pipe$2 = hash_to_uuid_value(_pipe$1, v5_version);
    let _pipe$3 = new Uuid(_pipe$2);
    return new Ok(_pipe$3);
  } else {
    return new Error(undefined);
  }
}

const v7_version = 7;

export function v7_from_millisec(timestamp) {
  let $ = $crypto.strong_random_bytes(10);
  if ($.bitSize !== 80) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "youid/uuid",
      298,
      "v7_from_millisec",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 7301,
        end: 7386,
        pattern_start: 7312,
        pattern_end: 7349
      }
    )
  }
  let a = bitArraySliceToInt($, 0, 12, true, false);
  let b = bitArraySliceToInt($, 12, 74, true, false);
  let value = toBitArray([
    sizedInt(timestamp, 48, true),
    sizedInt(v7_version, 4, true),
    sizedInt(a, 12, true),
    sizedInt(rfc_variant, 2, true),
    sizedInt(b, 62, true),
  ]);
  return new Uuid(value);
}

export function v7() {
  let _block;
  let _pipe = $timestamp.system_time();
  _block = $timestamp.to_unix_seconds_and_nanoseconds(_pipe);
  let $ = _block;
  let sec = $[0];
  let ns = $[1];
  return v7_from_millisec(sec * 1000 + (divideInt(ns, 1_000_000)));
}

export function v7_string() {
  let _pipe = v7();
  return format(_pipe, new String());
}

export const nil = /* @__PURE__ */ new Uuid(
  /* @__PURE__ */ toBitArray([sizedInt(0, 128, true)]),
);

export const nil_string = "00000000-0000-0000-0000-000000000000";
